import type { TLaunchpadLaneId, TLaunchpadTileId } from './interfaces/ILaunchpadLane';

export default function isLaunchpadTileVcmGated(
  laneId: TLaunchpadLaneId,
  tileId: TLaunchpadTileId,
): boolean {
  if (laneId === 'reporting') {
    return false;
  }

  if (laneId === 'visualize' && tileId === 'map') {
    return false;
  }

  if (laneId === 'visualize') {
    return true;
  }

  return laneId === 'understand' || laneId === 'plan' || laneId === 'act';
}
